import Home from '@/views/Home'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/:affiliate',
    name: 'affiliate',
    component: Home
  }
]

export default routes
